<template>
<section class="sm-account__main">
  <div class="sm-wrap">
    <div class="sm-account__main-inner">
      <tabs-elem
        :tabs="tabs"
        :type="'links'"
        :scroll="true"
      />

      <components 
        :is='currentTab'
        :userPlanProp="userPlan"
        :userAccountProp="userAccount"
        @callMethod="callMethod"
      />
    </div>
  </div>
</section>
  
</template>
<script>
import Phone from '@/views/customer/pages/account/components/Phone';
import LiveAnswering from '@/views/customer/pages/account/components/LiveAnswering';
import Forwarding from '@/views/customer/pages/account/components/Forwarding';
import Activity from '@/views/customer/pages/account/components/Activity';
import PlansAndBilling from '@/views/customer/pages/account/components/PlansAndBilling';
import Referrals from '@/views/customer/pages/account/components/Referrals';
import { mapActions, mapGetters } from 'vuex';
import Tabs from '@/components/Tabs';

export default {
  name: 'account-tabs',
  components: {
    'account': () => import('@/views/customer/pages/account/components/Account'),
    'extras': () => import('@/views/customer/pages/account/components/Extras'),

    'phone': Phone,
    'live-answering': LiveAnswering,
    'forwarding': Forwarding,
    'activity': Activity,
    'plans_and_billing': PlansAndBilling,
    'referrals': Referrals,
    'tabs-elem': Tabs
  },
  data() {
    return {
      allTabs: [
        {
          tab: 'account',
          text: 'Account'
        },
        {
          tab: 'forwarding',
          text: 'Addresses',
          // plan_field: 'has_mail_forwarding'
        },
        {
          tab: 'extras',
          text: 'Additional Services',
          levels: [2, 3]
        },
        {
          tab: 'phone',
          text: 'Virtual Phone Number',
          plan_field: 'phone_service_enabled',
          levels: [2, 3]
        },
        {
          tab: 'live-answering',
          text: 'Live Answering',
          plan_field: 'has_live_receptionist',
          levels: [2, 3]
        },
        {
          tab: 'activity',
          text: 'Activity',
          levels: [2, 3]
        },
        {
          tab: 'plans_and_billing',
          text: 'Plans & Billing',
          levels: [2, 3]
        },
        // {
        //   tab: 'referrals',
        //   text: 'Referrals',
        //   levels: [3]
        // },
      ],
    }
  },
  computed: {
    ...mapGetters({
      userAccount: 'account/userAccount',
      userPlan: 'account/userPlan',
      provider: 'provider'
    }),
    tabs() {
      return this.allTabs.filter(tab => {
        if(this.userAccount.type == "AdditionalRecipient" && tab.tab != 'account'){
          return false;
        }
        if (Object.keys(this.userAccount).length && (Object.keys(this.userPlan).length || this.provider.client_level == 1)) {
          if (tab.hasOwnProperty('levels') && !tab.levels.includes(this.userAccount.level))
            return false;

          if (
            tab.hasOwnProperty('plan_field') && 
            this.userPlan.hasOwnProperty(tab.plan_field) && 
            !this.userPlan[tab.plan_field]
          )
            return false;
        }

        return true;
      });
    },
    currentTab() {
      let query = this.$route.query;

      if (query.tab) {
        let newTab = this.tabs.find(item => item.tab == query.tab);
        
        return newTab ? newTab.tab : this.tabs[0].tab;
      } else {
        return this.tabs[0].tab;
      }
    }
  },
  methods: {
    ...mapActions({
      updateUser: 'account/updateUser',
      getUserAccount: 'account/userData',
      getAllNotarize: 'account/getAllNotarize',
      sendNotarize: 'account/sendNotarize',
      confirmSendNotarize1583: 'account/confirmSendNotarize1583',
      cancelNotarize1583: 'account/cancelNotarize1583'
    }),
    callMethod(method, callback, err, ...params) {
      if (!this[method])
        return false;

      this[method](...params)
        .then((res) => callback(res))
        .catch(e => err(e));
    }
  }
}
</script>

<style lang="scss">
  .sm-account__main {
    position: relative;
    
    &-inner {
      position: relative;
      margin: 34px 0 150px;

      & > .sm-tabs {
        margin-bottom: 30px;
      }
    }
  }
</style>
